export default __webpack_public_path__ + "static/media/deal.0506573c.png";